import React from "react";
import { ListOfSessions } from "./ListOfSessions";

const Coaching = () => {
  return (
    <>

      <ListOfSessions />
    </>
  );
};
export { Coaching };
